import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/favicon.png'


const _hoisted_1 = { class: "logo position-absolute start-0 end-0 top-0 bg-black" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo-icon"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold ms-10" }, "Adlash", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-caret-double-right" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "sidebar-menu" }
const _hoisted_8 = {
  class: "sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion",
  id: "sidebarNavAccordion"
}
const _hoisted_9 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseOne",
  "aria-expanded": "true",
  "aria-controls": "sidebarCollapseOne"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-more-1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Dashboard")
], -1)
const _hoisted_11 = {
  id: "sidebarCollapseOne",
  class: "accordion-collapse collapse show",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_12 = { class: "accordion-body" }
const _hoisted_13 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_14 = { class: "sidebar-sub-menu-item" }
const _hoisted_15 = { class: "sidebar-sub-menu-item" }
const _hoisted_16 = { class: "sidebar-sub-menu-item" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "new-badge fw-medium d-inline-block" }, "Hot", -1)
const _hoisted_18 = { class: "sidebar-sub-menu-item" }
const _hoisted_19 = { class: "sidebar-sub-menu-item" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "new-badge fw-medium d-inline-block" }, "Hot", -1)
const _hoisted_21 = { class: "sidebar-nav-item" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-folder" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "File Manager", -1)
const _hoisted_24 = { class: "sidebar-nav-item" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-award-1" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Changelog", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("li", { class: "sub-title sidebar-nav-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-block text-uppercase fw-medium" }, "Apps")
], -1)
const _hoisted_28 = { class: "sidebar-nav-item" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-date-1" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Calendar", -1)
const _hoisted_31 = { class: "sidebar-nav-item" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chat-1" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Chat", -1)
const _hoisted_34 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseTwo",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseTwo"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-rocket" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "CRM")
], -1)
const _hoisted_36 = {
  id: "sidebarCollapseTwo",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_37 = { class: "accordion-body" }
const _hoisted_38 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_39 = { class: "sidebar-sub-menu-item" }
const _hoisted_40 = { class: "sidebar-sub-menu-item" }
const _hoisted_41 = { class: "sidebar-sub-menu-item" }
const _hoisted_42 = { class: "sidebar-sub-menu-item" }
const _hoisted_43 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseThree",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseThree"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-arroba" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Emails")
], -1)
const _hoisted_45 = {
  id: "sidebarCollapseThree",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_46 = { class: "accordion-body" }
const _hoisted_47 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_48 = { class: "sidebar-sub-menu-item" }
const _hoisted_49 = { class: "sidebar-sub-menu-item" }
const _hoisted_50 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseFour",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseFour"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-trolley-cart" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Ecommerce")
], -1)
const _hoisted_52 = {
  id: "sidebarCollapseFour",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_53 = { class: "accordion-body" }
const _hoisted_54 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_55 = { class: "sidebar-sub-menu-item" }
const _hoisted_56 = { class: "sidebar-sub-menu-item" }
const _hoisted_57 = { class: "sidebar-sub-menu-item" }
const _hoisted_58 = { class: "sidebar-sub-menu-item" }
const _hoisted_59 = { class: "sidebar-sub-menu-item" }
const _hoisted_60 = { class: "sidebar-sub-menu-item" }
const _hoisted_61 = { class: "sidebar-sub-menu-item" }
const _hoisted_62 = { class: "sidebar-sub-menu-item" }
const _hoisted_63 = { class: "sidebar-sub-menu-item" }
const _hoisted_64 = { class: "sidebar-sub-menu-item" }
const _hoisted_65 = { class: "sidebar-sub-menu-item" }
const _hoisted_66 = { class: "sidebar-sub-menu-item" }
const _hoisted_67 = { class: "sidebar-sub-menu-item" }
const _hoisted_68 = { class: "sidebar-sub-menu-item" }
const _hoisted_69 = { class: "sidebar-sub-menu-item" }
const _hoisted_70 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseFive",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseFive"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-magistrate" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "E-learning")
], -1)
const _hoisted_72 = {
  id: "sidebarCollapseFive",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_73 = { class: "accordion-body" }
const _hoisted_74 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_75 = { class: "sidebar-sub-menu-item" }
const _hoisted_76 = { class: "sidebar-sub-menu-item" }
const _hoisted_77 = { class: "sidebar-sub-menu-item" }
const _hoisted_78 = { class: "sidebar-sub-menu-item" }
const _hoisted_79 = { class: "sidebar-sub-menu-item" }
const _hoisted_80 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseSix",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseSix"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-headphones" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Support Desk")
], -1)
const _hoisted_82 = {
  id: "sidebarCollapseSix",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_83 = { class: "accordion-body" }
const _hoisted_84 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_85 = { class: "sidebar-sub-menu-item" }
const _hoisted_86 = { class: "sidebar-sub-menu-item" }
const _hoisted_87 = { class: "sidebar-sub-menu-item" }
const _hoisted_88 = { class: "sidebar-sub-menu-item" }
const _hoisted_89 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseSeven",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseSeven"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-layer-2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Projects")
], -1)
const _hoisted_91 = {
  id: "sidebarCollapseSeven",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_92 = { class: "accordion-body" }
const _hoisted_93 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_94 = { class: "sidebar-sub-menu-item" }
const _hoisted_95 = { class: "sidebar-sub-menu-item" }
const _hoisted_96 = { class: "sidebar-sub-menu-item" }
const _hoisted_97 = { class: "sidebar-sub-menu-item" }
const _hoisted_98 = { class: "sidebar-sub-menu-item" }
const _hoisted_99 = { class: "sidebar-sub-menu-item" }
const _hoisted_100 = { class: "sidebar-nav-item" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-extension" }, null, -1)
const _hoisted_102 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Kanban", -1)
const _hoisted_103 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseEight",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseEight"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-ticket" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Events")
], -1)
const _hoisted_105 = {
  id: "sidebarCollapseEight",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_106 = { class: "accordion-body" }
const _hoisted_107 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_108 = { class: "sidebar-sub-menu-item" }
const _hoisted_109 = { class: "sidebar-sub-menu-item" }
const _hoisted_110 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseNine",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseNine"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-share" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Social")
], -1)
const _hoisted_112 = {
  id: "sidebarCollapseNine",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_113 = { class: "accordion-body" }
const _hoisted_114 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_115 = { class: "sidebar-sub-menu-item" }
const _hoisted_116 = { class: "sidebar-sub-menu-item" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("li", { class: "sub-title sidebar-nav-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-block text-uppercase fw-medium" }, "Pages")
], -1)
const _hoisted_118 = { class: "sidebar-nav-item" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-rocket" }, null, -1)
const _hoisted_120 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Starter", -1)
const _hoisted_121 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseTen",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseTen"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-shield-1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Authentication")
], -1)
const _hoisted_123 = {
  id: "sidebarCollapseTen",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_124 = { class: "accordion-body" }
const _hoisted_125 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_126 = { class: "sidebar-sub-menu-item" }
const _hoisted_127 = { class: "sidebar-sub-menu-item" }
const _hoisted_128 = { class: "sidebar-sub-menu-item" }
const _hoisted_129 = { class: "sidebar-sub-menu-item" }
const _hoisted_130 = { class: "sidebar-sub-menu-item" }
const _hoisted_131 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseEleven",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseEleven"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user-3" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Users")
], -1)
const _hoisted_133 = {
  id: "sidebarCollapseEleven",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_134 = { class: "accordion-body" }
const _hoisted_135 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_136 = { class: "sidebar-sub-menu-item" }
const _hoisted_137 = { class: "sidebar-sub-menu-item" }
const _hoisted_138 = { class: "sidebar-nav-item" }
const _hoisted_139 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-price-tag-2" }, null, -1)
const _hoisted_140 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Pricing", -1)
const _hoisted_141 = { class: "sidebar-nav-item" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-communication" }, null, -1)
const _hoisted_143 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "FAQ", -1)
const _hoisted_144 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseTwelve",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseTwelve"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-settings" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Miscellaneous")
], -1)
const _hoisted_146 = {
  id: "sidebarCollapseTwelve",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_147 = { class: "accordion-body" }
const _hoisted_148 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_149 = { class: "sidebar-sub-menu-item" }
const _hoisted_150 = { class: "sidebar-sub-menu-item" }
const _hoisted_151 = { class: "sidebar-sub-menu-item" }
const _hoisted_152 = { class: "sidebar-nav-item" }
const _hoisted_153 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-warning" }, null, -1)
const _hoisted_154 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Errors", -1)
const _hoisted_155 = /*#__PURE__*/_createElementVNode("li", { class: "sub-title sidebar-nav-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-block text-uppercase fw-medium" }, "Modules")
], -1)
const _hoisted_156 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_157 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseThirteen",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseThirteen"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-form" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Forms")
], -1)
const _hoisted_158 = {
  id: "sidebarCollapseThirteen",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_159 = { class: "accordion-body" }
const _hoisted_160 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_161 = { class: "sidebar-sub-menu-item" }
const _hoisted_162 = { class: "sidebar-sub-menu-item" }
const _hoisted_163 = { class: "sidebar-sub-menu-item" }
const _hoisted_164 = { class: "sidebar-sub-menu-item" }
const _hoisted_165 = { class: "sidebar-sub-menu-item" }
const _hoisted_166 = { class: "sidebar-sub-menu-item" }
const _hoisted_167 = { class: "sidebar-sub-menu-item" }
const _hoisted_168 = { class: "sidebar-sub-menu-item" }
const _hoisted_169 = { class: "sidebar-sub-menu-item" }
const _hoisted_170 = { class: "sidebar-sub-menu-item" }
const _hoisted_171 = { class: "sidebar-nav-item" }
const _hoisted_172 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-table" }, null, -1)
const _hoisted_173 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Tables", -1)
const _hoisted_174 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_175 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseFourteen",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseFourteen"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pie-chart" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Charts")
], -1)
const _hoisted_176 = {
  id: "sidebarCollapseFourteen",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_177 = { class: "accordion-body" }
const _hoisted_178 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_179 = { class: "sidebar-sub-menu-item" }
const _hoisted_180 = { class: "sidebar-sub-menu-item" }
const _hoisted_181 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_182 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseFifteen",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseFifteen"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-shapes" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Icons")
], -1)
const _hoisted_183 = {
  id: "sidebarCollapseFifteen",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_184 = { class: "accordion-body" }
const _hoisted_185 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_186 = { class: "sidebar-sub-menu-item" }
const _hoisted_187 = { class: "sidebar-sub-menu-item" }
const _hoisted_188 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_189 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseSixteen",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseSixteen"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-map" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Maps")
], -1)
const _hoisted_190 = {
  id: "sidebarCollapseSixteen",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_191 = { class: "accordion-body" }
const _hoisted_192 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_193 = { class: "sidebar-sub-menu-item" }
const _hoisted_194 = { class: "sidebar-sub-menu-item" }
const _hoisted_195 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_196 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseSeventeen",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseSeventeen"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-track" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Extended UI")
], -1)
const _hoisted_197 = {
  id: "sidebarCollapseSeventeen",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_198 = { class: "accordion-body" }
const _hoisted_199 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_200 = { class: "sidebar-sub-menu-item" }
const _hoisted_201 = { class: "sidebar-sub-menu-item" }
const _hoisted_202 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_203 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseEighteen",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseEighteen"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-layer-2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "UI Elements")
], -1)
const _hoisted_204 = {
  id: "sidebarCollapseEighteen",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_205 = { class: "accordion-body" }
const _hoisted_206 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_207 = { class: "sidebar-sub-menu-item" }
const _hoisted_208 = { class: "sidebar-sub-menu-item" }
const _hoisted_209 = { class: "sidebar-sub-menu-item" }
const _hoisted_210 = { class: "sidebar-sub-menu-item" }
const _hoisted_211 = { class: "sidebar-sub-menu-item" }
const _hoisted_212 = { class: "sidebar-sub-menu-item" }
const _hoisted_213 = { class: "sidebar-sub-menu-item" }
const _hoisted_214 = { class: "sidebar-sub-menu-item" }
const _hoisted_215 = { class: "sidebar-sub-menu-item" }
const _hoisted_216 = { class: "sidebar-sub-menu-item" }
const _hoisted_217 = { class: "sidebar-sub-menu-item" }
const _hoisted_218 = { class: "sidebar-sub-menu-item" }
const _hoisted_219 = { class: "sidebar-sub-menu-item" }
const _hoisted_220 = { class: "sidebar-sub-menu-item" }
const _hoisted_221 = { class: "sidebar-sub-menu-item" }
const _hoisted_222 = { class: "sidebar-sub-menu-item" }
const _hoisted_223 = { class: "sidebar-sub-menu-item" }
const _hoisted_224 = { class: "sidebar-sub-menu-item" }
const _hoisted_225 = { class: "sidebar-sub-menu-item" }
const _hoisted_226 = { class: "sidebar-sub-menu-item" }
const _hoisted_227 = { class: "sidebar-sub-menu-item" }
const _hoisted_228 = { class: "sidebar-sub-menu-item" }
const _hoisted_229 = { class: "sidebar-sub-menu-item" }
const _hoisted_230 = { class: "sidebar-sub-menu-item" }
const _hoisted_231 = { class: "sidebar-sub-menu-item" }
const _hoisted_232 = { class: "sidebar-sub-menu-item" }
const _hoisted_233 = { class: "sidebar-sub-menu-item" }
const _hoisted_234 = { class: "sidebar-sub-menu-item" }
const _hoisted_235 = { class: "sidebar-sub-menu-item" }
const _hoisted_236 = { class: "sidebar-sub-menu-item" }
const _hoisted_237 = { class: "sidebar-sub-menu-item" }
const _hoisted_238 = { class: "sidebar-sub-menu-item" }
const _hoisted_239 = { class: "sidebar-sub-menu-item" }
const _hoisted_240 = { class: "sidebar-sub-menu-item" }
const _hoisted_241 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_242 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseNineteen",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseNineteen"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-project" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Utilities")
], -1)
const _hoisted_243 = {
  id: "sidebarCollapseNineteen",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_244 = { class: "accordion-body" }
const _hoisted_245 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_246 = { class: "sidebar-sub-menu-item" }
const _hoisted_247 = { class: "sidebar-sub-menu-item" }
const _hoisted_248 = { class: "sidebar-sub-menu-item" }
const _hoisted_249 = { class: "sidebar-sub-menu-item" }
const _hoisted_250 = { class: "sidebar-sub-menu-item" }
const _hoisted_251 = { class: "sidebar-sub-menu-item" }
const _hoisted_252 = { class: "sidebar-sub-menu-item" }
const _hoisted_253 = { class: "sidebar-sub-menu-item" }
const _hoisted_254 = { class: "sidebar-sub-menu-item" }
const _hoisted_255 = { class: "sidebar-sub-menu-item" }
const _hoisted_256 = { class: "sidebar-sub-menu-item" }
const _hoisted_257 = { class: "sidebar-sub-menu-item" }
const _hoisted_258 = { class: "sidebar-sub-menu-item" }
const _hoisted_259 = { class: "sidebar-sub-menu-item" }
const _hoisted_260 = { class: "sidebar-sub-menu-item" }
const _hoisted_261 = { class: "sidebar-sub-menu-item" }
const _hoisted_262 = { class: "sidebar-sub-menu-item" }
const _hoisted_263 = { class: "sidebar-sub-menu-item" }
const _hoisted_264 = { class: "sidebar-sub-menu-item" }
const _hoisted_265 = { class: "sidebar-sub-menu-item" }
const _hoisted_266 = { class: "sidebar-sub-menu-item" }
const _hoisted_267 = { class: "sidebar-sub-menu-item" }
const _hoisted_268 = { class: "sidebar-sub-menu-item" }
const _hoisted_269 = { class: "sidebar-sub-menu-item" }
const _hoisted_270 = { class: "sidebar-sub-menu-item" }
const _hoisted_271 = { class: "sidebar-sub-menu-item" }
const _hoisted_272 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_273 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseTwenty",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseTwenty"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-widget" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Widgets")
], -1)
const _hoisted_274 = {
  id: "sidebarCollapseTwenty",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_275 = { class: "accordion-body" }
const _hoisted_276 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_277 = { class: "sidebar-sub-menu-item" }
const _hoisted_278 = { class: "sidebar-sub-menu-item" }
const _hoisted_279 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_280 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseTwentyOne",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseTwentyOne"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-sugar-cubes" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Pages")
], -1)
const _hoisted_281 = {
  id: "sidebarCollapseTwentyOne",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_282 = { class: "accordion-body" }
const _hoisted_283 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_284 = { class: "sidebar-sub-menu-item" }
const _hoisted_285 = { class: "sidebar-sub-menu-item" }
const _hoisted_286 = { class: "sidebar-sub-menu-item" }
const _hoisted_287 = { class: "sidebar-sub-menu-item" }
const _hoisted_288 = { class: "sidebar-sub-menu-item" }
const _hoisted_289 = { class: "sidebar-sub-menu-item" }
const _hoisted_290 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_291 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseTwentyTwo",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseTwentyTwo"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-setting" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Settings")
], -1)
const _hoisted_292 = {
  id: "sidebarCollapseTwentyTwo",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_293 = { class: "accordion-body" }
const _hoisted_294 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_295 = { class: "sidebar-sub-menu-item" }
const _hoisted_296 = { class: "sidebar-sub-menu-item" }
const _hoisted_297 = { class: "sidebar-sub-menu-item" }
const _hoisted_298 = { class: "sidebar-sub-menu-item" }
const _hoisted_299 = { class: "sidebar-nav-item" }
const _hoisted_300 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-edit" }, null, -1)
const _hoisted_301 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Blank Page", -1)
const _hoisted_302 = /*#__PURE__*/_createStaticVNode("<li class=\"sidebar-nav-item accordion-item bg-transparent border-0 rounded-0\"><a href=\"#\" class=\"accordion-button collapsed rounded-0 shadow-none bg-transparent d-block\" data-bs-toggle=\"collapse\" data-bs-target=\"#sidebarCollapseTwentyThree\" aria-expanded=\"true\" aria-controls=\"sidebarCollapseTwentyThree\"><i class=\"flaticon-download\"></i><span class=\"title\">Multi Level</span></a><div id=\"sidebarCollapseTwentyThree\" class=\"accordion-collapse collapse\" data-bs-parent=\"#sidebarNavAccordion\"><div class=\"accordion-body\"><ul class=\"sidebar-sub-menu ps-0 mb-0 list-unstyled\"><li class=\"sidebar-sub-menu-item\"><a href=\"#\" class=\"sidebar-sub-menu-link\"> Level One </a></li><li class=\"sidebar-sub-menu-item\"><a href=\"#\" class=\"sidebar-sub-menu-link\"> Level Two </a></li><li class=\"sidebar-sub-menu-item\"><ul class=\"sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion\" id=\"sidebarInnerNavAccordion\"><li class=\"sidebar-nav-item accordion-item bg-transparent border-0 rounded-0\"><a href=\"#\" class=\"accordion-button collapsed rounded-0 shadow-none bg-transparent d-block\" data-bs-toggle=\"collapse\" data-bs-target=\"#sidebarInnerCollapseOne\" aria-expanded=\"true\" aria-controls=\"sidebarInnerCollapseOne\"><span class=\"title\">Second Level</span></a><div id=\"sidebarInnerCollapseOne\" class=\"accordion-collapse collapse\" data-bs-parent=\"#sidebarInnerNavAccordion\"><div class=\"accordion-body\"><ul class=\"sidebar-sub-menu ps-0 mb-0 list-unstyled\"><li class=\"sidebar-sub-menu-item\"><a href=\"#\" class=\"sidebar-sub-menu-link\"> Level One </a></li><li class=\"sidebar-sub-menu-item\"><a href=\"#\" class=\"sidebar-sub-menu-link\"> Level Two </a></li><li class=\"sidebar-sub-menu-item\"><ul class=\"sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion\" id=\"sidebarInner2NavAccordion\"><li class=\"sidebar-nav-item accordion-item bg-transparent border-0 rounded-0\"><a href=\"#\" class=\"accordion-button collapsed rounded-0 shadow-none bg-transparent d-block\" data-bs-toggle=\"collapse\" data-bs-target=\"#sidebarInner2CollapseOne\" aria-expanded=\"true\" aria-controls=\"sidebarInner2CollapseOne\"><span class=\"title\">Third Level</span></a><div id=\"sidebarInner2CollapseOne\" class=\"accordion-collapse collapse\" data-bs-parent=\"#sidebarInner2NavAccordion\"><div class=\"accordion-body\"><ul class=\"sidebar-sub-menu ps-0 mb-0 list-unstyled\"><li class=\"sidebar-sub-menu-item\"><a href=\"#\" class=\"sidebar-sub-menu-link\"> One </a></li><li class=\"sidebar-sub-menu-item\"><a href=\"#\" class=\"sidebar-sub-menu-link\"> Two </a></li></ul></div></div></li></ul></li></ul></div></div></li></ul></li></ul></div></div></li><li class=\"sidebar-nav-item\"><a href=\"/docs\" target=\"_blank\" class=\"sidebar-nav-link d-block\"><i class=\"flaticon-document\"></i><span class=\"title\">Documentation</span></a></li>", 2)
const _hoisted_304 = { class: "sidebar-nav-item" }
const _hoisted_305 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-logout" }, null, -1)
const _hoisted_306 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Logout", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
      { active: _ctx.stateStoreInstance.open },
    ]),
    id: "sidebar-area"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "d-flex align-items-center text-white text-decoration-none"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4,
      _createElementVNode("button", {
        class: "sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
      }, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("ul", _hoisted_8, [
        _createElementVNode("li", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("ul", _hoisted_13, [
                _createElementVNode("li", _hoisted_14, [
                  _createVNode(_component_router_link, {
                    to: "/template",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Ecommerce ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_15, [
                  _createVNode(_component_router_link, {
                    to: "/project-management",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Project Management ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_16, [
                  _createVNode(_component_router_link, {
                    to: "/support-desk",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Support Desk "),
                      _hoisted_17
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_18, [
                  _createVNode(_component_router_link, {
                    to: "/lms-courses",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" LMS Courses ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_19, [
                  _createVNode(_component_router_link, {
                    to: "/crm-system",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" CRM System "),
                      _hoisted_20
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_21, [
          _createVNode(_component_router_link, {
            to: "/file-manager",
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => [
              _hoisted_22,
              _hoisted_23
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_24, [
          _createVNode(_component_router_link, {
            to: "/changelog",
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => [
              _hoisted_25,
              _hoisted_26
            ]),
            _: 1
          })
        ]),
        _hoisted_27,
        _createElementVNode("li", _hoisted_28, [
          _createVNode(_component_router_link, {
            to: "/calendar",
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => [
              _hoisted_29,
              _hoisted_30
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_31, [
          _createVNode(_component_router_link, {
            to: "/chat",
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => [
              _hoisted_32,
              _hoisted_33
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("ul", _hoisted_38, [
                _createElementVNode("li", _hoisted_39, [
                  _createVNode(_component_router_link, {
                    to: "/leads",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Leads")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_40, [
                  _createVNode(_component_router_link, {
                    to: "/lead-details",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Lead Details ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_41, [
                  _createVNode(_component_router_link, {
                    to: "/crm-contacts",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Contacts ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_42, [
                  _createVNode(_component_router_link, {
                    to: "/crm-customers",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Customers ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_43, [
          _hoisted_44,
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("ul", _hoisted_47, [
                _createElementVNode("li", _hoisted_48, [
                  _createVNode(_component_router_link, {
                    to: "/emails",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Inbox ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_49, [
                  _createVNode(_component_router_link, {
                    to: "/read-email",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Read Email ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_50, [
          _hoisted_51,
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("ul", _hoisted_54, [
                _createElementVNode("li", _hoisted_55, [
                  _createVNode(_component_router_link, {
                    to: "/products-temp",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Products Grid ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_56, [
                  _createVNode(_component_router_link, {
                    to: "/products-list",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Products List ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_57, [
                  _createVNode(_component_router_link, {
                    to: "/add-product",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Add Product ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_58, [
                  _createVNode(_component_router_link, {
                    to: "/product-details",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Product Details ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_59, [
                  _createVNode(_component_router_link, {
                    to: "/orders-temp",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Orders ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_60, [
                  _createVNode(_component_router_link, {
                    to: "/order-details-temp",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Order Details ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_61, [
                  _createVNode(_component_router_link, {
                    to: "/cart",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Shopping Cart ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_62, [
                  _createVNode(_component_router_link, {
                    to: "/checkout",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Checkout ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_63, [
                  _createVNode(_component_router_link, {
                    to: "/customers",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Customers ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_64, [
                  _createVNode(_component_router_link, {
                    to: "/sellers",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Sellers ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_65, [
                  _createVNode(_component_router_link, {
                    to: "/reviews",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Manage Reviews ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_66, [
                  _createVNode(_component_router_link, {
                    to: "/refund",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Refund ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_67, [
                  _createVNode(_component_router_link, {
                    to: "/invoice",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Invoice ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_68, [
                  _createVNode(_component_router_link, {
                    to: "/invoice-details",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Invoice Details ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_69, [
                  _createVNode(_component_router_link, {
                    to: "/order-tracking",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Order Tracking ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_70, [
          _hoisted_71,
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("ul", _hoisted_74, [
                _createElementVNode("li", _hoisted_75, [
                  _createVNode(_component_router_link, {
                    to: "/courses-list",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Courses List ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_76, [
                  _createVNode(_component_router_link, {
                    to: "/courses-grid",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Courses Grid ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_77, [
                  _createVNode(_component_router_link, {
                    to: "/course-details",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Course Details ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_78, [
                  _createVNode(_component_router_link, {
                    to: "/lessons-preview",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Lessons Preview ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_79, [
                  _createVNode(_component_router_link, {
                    to: "/edit-course",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Edit Course ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_80, [
          _hoisted_81,
          _createElementVNode("div", _hoisted_82, [
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("ul", _hoisted_84, [
                _createElementVNode("li", _hoisted_85, [
                  _createVNode(_component_router_link, {
                    to: "/support-desk-list",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" List View ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_86, [
                  _createVNode(_component_router_link, {
                    to: "/support-desk-card",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Card View ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_87, [
                  _createVNode(_component_router_link, {
                    to: "/contacts",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Contacts ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_88, [
                  _createVNode(_component_router_link, {
                    to: "/ticket-preview",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Ticket Preview ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_89, [
          _hoisted_90,
          _createElementVNode("div", _hoisted_91, [
            _createElementVNode("div", _hoisted_92, [
              _createElementVNode("ul", _hoisted_93, [
                _createElementVNode("li", _hoisted_94, [
                  _createVNode(_component_router_link, {
                    to: "/projects-list",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Projects List ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_95, [
                  _createVNode(_component_router_link, {
                    to: "/projects-grid",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Projects Grid ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_96, [
                  _createVNode(_component_router_link, {
                    to: "/create-new-project",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Create New Project ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_97, [
                  _createVNode(_component_router_link, {
                    to: "/project-details",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Project Details ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_98, [
                  _createVNode(_component_router_link, {
                    to: "/to-do-list",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" To-do List ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_99, [
                  _createVNode(_component_router_link, {
                    to: "/projects-teams",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Teams ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_100, [
          _createVNode(_component_router_link, {
            to: "/kanban",
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => [
              _hoisted_101,
              _hoisted_102
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_103, [
          _hoisted_104,
          _createElementVNode("div", _hoisted_105, [
            _createElementVNode("div", _hoisted_106, [
              _createElementVNode("ul", _hoisted_107, [
                _createElementVNode("li", _hoisted_108, [
                  _createVNode(_component_router_link, {
                    to: "/events",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Events Grid ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_109, [
                  _createVNode(_component_router_link, {
                    to: "/event-details",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Event Details ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_110, [
          _hoisted_111,
          _createElementVNode("div", _hoisted_112, [
            _createElementVNode("div", _hoisted_113, [
              _createElementVNode("ul", _hoisted_114, [
                _createElementVNode("li", _hoisted_115, [
                  _createVNode(_component_router_link, {
                    to: "/social-timeline",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Timeline ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_116, [
                  _createVNode(_component_router_link, {
                    to: "/profile-settings",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Settings ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _hoisted_117,
        _createElementVNode("li", _hoisted_118, [
          _createVNode(_component_router_link, {
            to: "/starter",
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => [
              _hoisted_119,
              _hoisted_120
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_121, [
          _hoisted_122,
          _createElementVNode("div", _hoisted_123, [
            _createElementVNode("div", _hoisted_124, [
              _createElementVNode("ul", _hoisted_125, [
                _createElementVNode("li", _hoisted_126, [
                  _createVNode(_component_router_link, {
                    to: "/login",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Login ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_127, [
                  _createVNode(_component_router_link, {
                    to: "/register",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Register ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_128, [
                  _createVNode(_component_router_link, {
                    to: "/forgot-password",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Forgot Password ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_129, [
                  _createVNode(_component_router_link, {
                    to: "/reset-password",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Reset Password ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_130, [
                  _createVNode(_component_router_link, {
                    to: "/email-confirmation",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Mail Confirmation ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_131, [
          _hoisted_132,
          _createElementVNode("div", _hoisted_133, [
            _createElementVNode("div", _hoisted_134, [
              _createElementVNode("ul", _hoisted_135, [
                _createElementVNode("li", _hoisted_136, [
                  _createVNode(_component_router_link, {
                    to: "/users-list",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Users List ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_137, [
                  _createVNode(_component_router_link, {
                    to: "/add-user",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Add User ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_138, [
          _createVNode(_component_router_link, {
            to: "/pricing",
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => [
              _hoisted_139,
              _hoisted_140
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_141, [
          _createVNode(_component_router_link, {
            to: "/faq",
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => [
              _hoisted_142,
              _hoisted_143
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_144, [
          _hoisted_145,
          _createElementVNode("div", _hoisted_146, [
            _createElementVNode("div", _hoisted_147, [
              _createElementVNode("ul", _hoisted_148, [
                _createElementVNode("li", _hoisted_149, [
                  _createVNode(_component_router_link, {
                    to: "/ui-swiper-slider",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Swiper Slider ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_150, [
                  _createVNode(_component_router_link, {
                    to: "/privacy-policy",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Privacy Policy ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_151, [
                  _createVNode(_component_router_link, {
                    to: "/terms-conditions",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Terms & Conditions ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_152, [
          _createVNode(_component_router_link, {
            to: "/error-404",
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => [
              _hoisted_153,
              _hoisted_154
            ]),
            _: 1
          })
        ]),
        _hoisted_155,
        _createElementVNode("li", _hoisted_156, [
          _hoisted_157,
          _createElementVNode("div", _hoisted_158, [
            _createElementVNode("div", _hoisted_159, [
              _createElementVNode("ul", _hoisted_160, [
                _createElementVNode("li", _hoisted_161, [
                  _createVNode(_component_router_link, {
                    to: "/forms-overview",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Basic Elements ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_162, [
                  _createVNode(_component_router_link, {
                    to: "/forms-form-control",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Form Controls ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_163, [
                  _createVNode(_component_router_link, {
                    to: "/forms-select",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Select ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_164, [
                  _createVNode(_component_router_link, {
                    to: "/forms-checks-radios",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Checks & Radios ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_165, [
                  _createVNode(_component_router_link, {
                    to: "/forms-range",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Range ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_166, [
                  _createVNode(_component_router_link, {
                    to: "/forms-input-group",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Input Group")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_167, [
                  _createVNode(_component_router_link, {
                    to: "/forms-floating-labels",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Floating Labels ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_168, [
                  _createVNode(_component_router_link, {
                    to: "/forms-layout",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Layout ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_169, [
                  _createVNode(_component_router_link, {
                    to: "/forms-validation",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Validation ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_170, [
                  _createVNode(_component_router_link, {
                    to: "/wizard",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Wizard")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_171, [
          _createVNode(_component_router_link, {
            to: "/tables",
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => [
              _hoisted_172,
              _hoisted_173
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_174, [
          _hoisted_175,
          _createElementVNode("div", _hoisted_176, [
            _createElementVNode("div", _hoisted_177, [
              _createElementVNode("ul", _hoisted_178, [
                _createElementVNode("li", _hoisted_179, [
                  _createVNode(_component_router_link, {
                    to: "/charts",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Charts ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_180, [
                  _createVNode(_component_router_link, {
                    to: "/mixed-charts",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Mixed Charts ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_181, [
          _hoisted_182,
          _createElementVNode("div", _hoisted_183, [
            _createElementVNode("div", _hoisted_184, [
              _createElementVNode("ul", _hoisted_185, [
                _createElementVNode("li", _hoisted_186, [
                  _createVNode(_component_router_link, {
                    to: "/flaticons",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Flaticon ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_187, [
                  _createVNode(_component_router_link, {
                    to: "/phosphoricons",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Phosphoricons ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_188, [
          _hoisted_189,
          _createElementVNode("div", _hoisted_190, [
            _createElementVNode("div", _hoisted_191, [
              _createElementVNode("ul", _hoisted_192, [
                _createElementVNode("li", _hoisted_193, [
                  _createVNode(_component_router_link, {
                    to: "/google-maps",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Google Maps ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_194, [
                  _createVNode(_component_router_link, {
                    to: "/leaflet-map",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Leaflet Map ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_195, [
          _hoisted_196,
          _createElementVNode("div", _hoisted_197, [
            _createElementVNode("div", _hoisted_198, [
              _createElementVNode("ul", _hoisted_199, [
                _createElementVNode("li", _hoisted_200, [
                  _createVNode(_component_router_link, {
                    to: "/ui-tree",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Tree ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_201, [
                  _createVNode(_component_router_link, {
                    to: "/editor",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Rich Text Editor ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_202, [
          _hoisted_203,
          _createElementVNode("div", _hoisted_204, [
            _createElementVNode("div", _hoisted_205, [
              _createElementVNode("ul", _hoisted_206, [
                _createElementVNode("li", _hoisted_207, [
                  _createVNode(_component_router_link, {
                    to: "/ui-accordion",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Accordion ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_208, [
                  _createVNode(_component_router_link, {
                    to: "/ui-alerts",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Alerts ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_209, [
                  _createVNode(_component_router_link, {
                    to: "/ui-avatars",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Avatars ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_210, [
                  _createVNode(_component_router_link, {
                    to: "/ui-badges",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Badges ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_211, [
                  _createVNode(_component_router_link, {
                    to: "/ui-breadcrumb",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Breadcrumb ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_212, [
                  _createVNode(_component_router_link, {
                    to: "/ui-buttons",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Buttons ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_213, [
                  _createVNode(_component_router_link, {
                    to: "/ui-button-group",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Button Group ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_214, [
                  _createVNode(_component_router_link, {
                    to: "/ui-carousel",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Carousel ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_215, [
                  _createVNode(_component_router_link, {
                    to: "/ui-close-button",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Close Button ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_216, [
                  _createVNode(_component_router_link, {
                    to: "/ui-color-background",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Color Background ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_217, [
                  _createVNode(_component_router_link, {
                    to: "/ui-colored-links",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Colored Links ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_218, [
                  _createVNode(_component_router_link, {
                    to: "/ui-collapse",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Collapse ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_219, [
                  _createVNode(_component_router_link, {
                    to: "/ui-dropdowns",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Dropdowns ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_220, [
                  _createVNode(_component_router_link, {
                    to: "/ui-datepicker",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Datepicker ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_221, [
                  _createVNode(_component_router_link, {
                    to: "/ui-figures",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Figures ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_222, [
                  _createVNode(_component_router_link, {
                    to: "/ui-icon-link",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Icon Link ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_223, [
                  _createVNode(_component_router_link, {
                    to: "/ui-list-group",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" List Group ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_224, [
                  _createVNode(_component_router_link, {
                    to: "/ui-modal",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Modal ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_225, [
                  _createVNode(_component_router_link, {
                    to: "/ui-navs-tabs",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Navs & Tabs ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_226, [
                  _createVNode(_component_router_link, {
                    to: "/ui-offcanvas",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Offcanvas ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_227, [
                  _createVNode(_component_router_link, {
                    to: "/ui-pagination",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Pagination ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_228, [
                  _createVNode(_component_router_link, {
                    to: "/ui-placeholders",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Placeholders ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_229, [
                  _createVNode(_component_router_link, {
                    to: "/ui-popovers",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Popovers ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_230, [
                  _createVNode(_component_router_link, {
                    to: "/ui-progress",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Progress ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_231, [
                  _createVNode(_component_router_link, {
                    to: "/ui-ratio",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Ratio ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_232, [
                  _createVNode(_component_router_link, {
                    to: "/ui-scrollspy",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Scrollspy ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_233, [
                  _createVNode(_component_router_link, {
                    to: "/ui-stacks",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Stacks ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_234, [
                  _createVNode(_component_router_link, {
                    to: "/ui-spinners",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Spinners ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_235, [
                  _createVNode(_component_router_link, {
                    to: "/ui-tables",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Tables ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_236, [
                  _createVNode(_component_router_link, {
                    to: "/ui-toasts",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Toasts ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_237, [
                  _createVNode(_component_router_link, {
                    to: "/ui-timeline",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Timeline ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_238, [
                  _createVNode(_component_router_link, {
                    to: "/ui-timepicker",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Timepicker ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_239, [
                  _createVNode(_component_router_link, {
                    to: "/ui-tooltips",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Tooltips ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_240, [
                  _createVNode(_component_router_link, {
                    to: "/ui-typography",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Typography ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_241, [
          _hoisted_242,
          _createElementVNode("div", _hoisted_243, [
            _createElementVNode("div", _hoisted_244, [
              _createElementVNode("ul", _hoisted_245, [
                _createElementVNode("li", _hoisted_246, [
                  _createVNode(_component_router_link, {
                    to: "/ui-background",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Background ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_247, [
                  _createVNode(_component_router_link, {
                    to: "/ui-borders",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Borders ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_248, [
                  _createVNode(_component_router_link, {
                    to: "/ui-colors",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Colors ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_249, [
                  _createVNode(_component_router_link, {
                    to: "/ui-clearfix",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Clearfix ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_250, [
                  _createVNode(_component_router_link, {
                    to: "/ui-display",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Display ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_251, [
                  _createVNode(_component_router_link, {
                    to: "/ui-flex",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Flex ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_252, [
                  _createVNode(_component_router_link, {
                    to: "/ui-float",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Float ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_253, [
                  _createVNode(_component_router_link, {
                    to: "/ui-focus-ring",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Focus Ring ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_254, [
                  _createVNode(_component_router_link, {
                    to: "/ui-grid",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Grid ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_255, [
                  _createVNode(_component_router_link, {
                    to: "/ui-gutters",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Gutters ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_256, [
                  _createVNode(_component_router_link, {
                    to: "/ui-interactions",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Interactions ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_257, [
                  _createVNode(_component_router_link, {
                    to: "/ui-link",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Link")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_258, [
                  _createVNode(_component_router_link, {
                    to: "/ui-object-fit",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Object Fit ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_259, [
                  _createVNode(_component_router_link, {
                    to: "/ui-opacity",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Opacity ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_260, [
                  _createVNode(_component_router_link, {
                    to: "/ui-overflow",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Overflow ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_261, [
                  _createVNode(_component_router_link, {
                    to: "/ui-position",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Position ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_262, [
                  _createVNode(_component_router_link, {
                    to: "/ui-shadows",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Shadows ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_263, [
                  _createVNode(_component_router_link, {
                    to: "/ui-sizing",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Sizing ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_264, [
                  _createVNode(_component_router_link, {
                    to: "/ui-spacing",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Spacing ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_265, [
                  _createVNode(_component_router_link, {
                    to: "/ui-text",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Text ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_266, [
                  _createVNode(_component_router_link, {
                    to: "/ui-text-truncation",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Text Truncation ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_267, [
                  _createVNode(_component_router_link, {
                    to: "/ui-vertical-align",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Vertical Alignment ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_268, [
                  _createVNode(_component_router_link, {
                    to: "/ui-vertical-rule",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Vertical Rule ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_269, [
                  _createVNode(_component_router_link, {
                    to: "/ui-visually-hidden",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Visually Hidden ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_270, [
                  _createVNode(_component_router_link, {
                    to: "/ui-visibility",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Visibility ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_271, [
                  _createVNode(_component_router_link, {
                    to: "/ui-z-index",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Z-index ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_272, [
          _hoisted_273,
          _createElementVNode("div", _hoisted_274, [
            _createElementVNode("div", _hoisted_275, [
              _createElementVNode("ul", _hoisted_276, [
                _createElementVNode("li", _hoisted_277, [
                  _createVNode(_component_router_link, {
                    to: "/cards",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Cards ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_278, [
                  _createVNode(_component_router_link, {
                    to: "/charts",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Charts ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_279, [
          _hoisted_280,
          _createElementVNode("div", _hoisted_281, [
            _createElementVNode("div", _hoisted_282, [
              _createElementVNode("ul", _hoisted_283, [
                _createElementVNode("li", _hoisted_284, [
                  _createVNode(_component_router_link, {
                    to: "/gallery",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Gallery ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_285, [
                  _createVNode(_component_router_link, {
                    to: "/maintenance",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Maintenance ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_286, [
                  _createVNode(_component_router_link, {
                    to: "/notifications",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Notifications ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_287, [
                  _createVNode(_component_router_link, {
                    to: "/connected-accounts",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Connected Accounts ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_288, [
                  _createVNode(_component_router_link, {
                    to: "/profile",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Profile ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_289, [
                  _createVNode(_component_router_link, {
                    to: "/search-result",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Search Result ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_290, [
          _hoisted_291,
          _createElementVNode("div", _hoisted_292, [
            _createElementVNode("div", _hoisted_293, [
              _createElementVNode("ul", _hoisted_294, [
                _createElementVNode("li", _hoisted_295, [
                  _createVNode(_component_router_link, {
                    to: "/account-settings",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Account Setting ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_296, [
                  _createVNode(_component_router_link, {
                    to: "/settings-change-password",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Change Password ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_297, [
                  _createVNode(_component_router_link, {
                    to: "/settings-social-links",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Social Link ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_298, [
                  _createVNode(_component_router_link, {
                    to: "/settings-privacy-policy",
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Privacy Policy ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_299, [
          _createVNode(_component_router_link, {
            to: "/blank-page",
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => [
              _hoisted_300,
              _hoisted_301
            ]),
            _: 1
          })
        ]),
        _hoisted_302,
        _createElementVNode("li", _hoisted_304, [
          _createVNode(_component_router_link, {
            to: "/logout",
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => [
              _hoisted_305,
              _hoisted_306
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 2))
}